// The app's lip sync: decode the cleaned take in the browser and run wLipSync on it (src/audio/lipsync/wlipsync.ts).
// Why wLipSync: docs/lip-sync-research.md.
import type { Cue } from "../../model/face";
import { RATE, wLipSync } from "./wlipsync";

// Any audio URL -> mono Float32 at 16 kHz (resampled by the browser).
async function decode16k(url: string) {
  const buf = await (await fetch(url)).arrayBuffer();
  const tmp = new AudioContext();
  const decoded = await tmp.decodeAudioData(buf);
  void tmp.close();
  const off = new OfflineAudioContext(1, Math.ceil(decoded.duration * RATE), RATE);
  const src = off.createBufferSource();
  src.buffer = decoded;
  src.connect(off.destination);
  src.start();
  return (await off.startRendering()).getChannelData(0);
}

export async function lipSyncUrl(url: string): Promise<Cue[]> {
  const cues = await wLipSync(await decode16k(url));
  if (!cues.length) throw new Error("Lip sync returned no mouth shapes.");
  return cues;
}
